import { combineReducers } from "redux";
import { getStartedReducer } from "./ui/get-started/get-started.slice";
import { phoneConfirmationReducer } from "./ui/phone-confirmation/phone-confirmation.slice";


const rootReducer = combineReducers({
    GetStarted: getStartedReducer,
    PhoneConfirmation: phoneConfirmationReducer
});

export default rootReducer;
